module.exports = __webpack_public_path__ + "img/Popular_Website_Moodfilm_V04_CLEAN.46ffadce.jpg";